import React, { useEffect, useRef, useState } from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from 'LanguageSwitcher';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const Header = () => {
  const { t } = useTranslation(); // Initialize translation

  const navigate = useNavigate();

  const { metaCart, cartList } = useSelector((state) => state.general);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isAuthenticated'));

  const [cartCount, setCartCount] = useState(
    isAuthenticated ? cartList?.length : localStorage.getItem('cartCount')
  );

  const location = useLocation();

  const searchRef = useRef(null);
  const categoryRef = useRef(null);
  const userMenuRef = useRef(null);
  const [isShaking, setIsShaking] = useState(false);
  const [isEmptyPulse, setIsEmptyPulse] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      function handleCartUpdated(e) {
        setCartCount(e.detail.count);
      }
      window.addEventListener('cartUpdated', handleCartUpdated);
      // قراءة القيمة الأولية
      const initialCount = parseInt(localStorage.getItem('cartCount') || '0', 10);
      setCartCount(initialCount);
      return () => {
        window.removeEventListener('cartUpdated', handleCartUpdated);
      };
    }
  }, []);
  useEffect(() => {
    if (cartList?.length > 0 || parseInt(localStorage.getItem('cartCount') || '0') > 0) {
      if (isAuthenticated) {
        setCartCount(cartList?.length);
      } else {
        setCartCount(parseInt(localStorage.getItem('cartCount') || '0'));
      }
      setIsEmptyPulse(false);
      const interval = setInterval(() => {
        setIsShaking(true);
        setTimeout(() => setIsShaking(false), 1000);
      }, 3000);
      return () => clearInterval(interval);
    } else {
      setIsEmptyPulse(true);
    }
  }, [cartList, isAuthenticated]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setIsSearchOpen(false);
      }
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setIsCategoryMenuOpen(false);
      }
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUser(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    /* const savedCartCount = localStorage.getItem("cartCount");
    if (savedCartCount) {
      setCartCount(parseInt(savedCartCount));
    }*/

    const authStatus = localStorage.getItem('isAuthenticated');
    setIsAuthenticated(authStatus === 'true');
  }, []);
  useEffect(() => {
    console.log(cartList);
    // setCartCount(cartList?.length);
  }, [cartCount, metaCart, cartList]);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.location.href = `/product-listing?search=${encodeURIComponent(searchQuery)}`;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    setIsAuthenticated(false);
    setIsUser(false);
    window.location.href = '/login';
  };

  const isActivePath = (path) => {
    return location.pathname === path;
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="w-full" role="banner">
      {/* Top Bar */}
      <div className="w-full bg-[#c90d2d]">
        <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center gap-4 py-2">
            <div className="flex items-center gap-2 ml-6">
              <div className="w-[22px] h-[22px]" />
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div className="w-full bg-white border-b-2 border-[#cecede]">
        <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col gap-6 py-4">
            {/* Logo and Search Row */}
            <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8">
              {/* Logo Section */}
              <div className="flex items-center gap-2 w-full lg:w-auto justify-center lg:justify-start">
                <Link
                  to="/home-page"
                  className="flex items-center space-x-2 hover:opacity-80 transition-smooth"
                >
                  <img src="/images/logo.png" alt="StarMart Logo" className="w-[110px] h-[58px]" />
                </Link>
              </div>

              {/* Search and Actions */}
              <div className="flex flex-col sm:flex-row items-center gap-4 w-full lg:flex-1">
                {/* Search Bar */}
                <div className="flex items-center w-full max-w-md lg:max-w-none lg:flex-1 border border-[#8b8ba3] rounded-lg bg-white">
                  <div className="bg-[#ca0d2d] p-5 rounded-l-lg rounded-r-lg">
                    <img src="/images/img_search.svg" alt="" className="w-[20px] h-[20px]" />
                  </div>
                  <input
                    type="text"
                    placeholder={t('search.placeholder')}
                    className="flex-1 px-5 py-4 text-sm text-[#6c6c6c] bg-transparent border-none outline-none"
                  />
                </div>

                {/* Language Selector */}
                <div className="hidden sm:flex items-center gap-2 px-3 py-3 border border-[#f3f3f3] rounded-lg bg-[#eceff6]">
                  <LanguageSwitcher />
                </div>

                {/* Login Button */}
                {isAuthenticated !== true ? (
                  <Button
                    text={t('login_register')}
                    className="bg-[#ca0d2d] text-white px-8 py-4 rounded-lg text-sm font-bold hover:opacity-90"
                    layout_width="auto"
                    padding="medium"
                    position="relative"
                    layout_gap="normal"
                    margin="none"
                    variant="primary"
                    size="medium"
                    onClick={() => (window.location.href = '/login')}
                  />
                ) : (
                  <Button
                    text={t('userMenu.signOut')}
                    className="bg-[#ca0d2d] text-white px-8 py-4 rounded-lg text-sm font-bold hover:opacity-90"
                    layout_width="auto"
                    padding="medium"
                    position="relative"
                    layout_gap="normal"
                    margin="none"
                    variant="primary"
                    size="medium"
                    onClick={() => {
                      localStorage.clear();
                      window.location.href = '/';
                    }}
                  />
                )}

                  {/* Cart - always visible */}
              <Link
                to="/shopping-cart"
                className="relative p-2 text-text-secondary hover:text-primary transition-smooth"
                aria-label="Shopping Cart"
              >
                <Icon
                  name="ShoppingCart"
                  size={20}
                  className={`${isShaking ? 'animate-shake' : ''} ${
                    isEmptyPulse ? 'animate-pulse-glow' : ''
                  }`}
                />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-accent text-white text-xs font-medium rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount > 99 ? '99+' : cartCount}
                  </span>
                )}
              </Link>
              </div>
            </div>

            {/* Navigation Menu */}
            <nav className="w-full" role="navigation">
              <button
                className="lg:hidden flex items-center justify-center w-full p-3 bg-gray-100 rounded-lg mb-4"
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
              >
                <span className="text-[#353543] font-medium">{t('menu')}</span>
                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              <div className={`${isMenuOpen ? 'block' : 'hidden'} lg:block`}>
                <ul
                  className="flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-20"
                  role="menubar"
                >
                  <li role="menuitem" aria-haspopup="true" aria-expanded="false">
                    <button
                      onClick={() => navigate('/product-listing')}
                      className="flex items-center gap-1 text-base text-[#353543] font-medium hover:text-[#ca0d2d] transition-colors"
                    >
                      {t('categories')}
                    </button>
                  </li>

                  <li role="menuitem" aria-haspopup="true" aria-expanded="false">
                    <button className="flex items-center gap-1 text-base text-[#353543] font-medium hover:text-[#ca0d2d] transition-colors">
                      {t('navigation.aboutUs')}
                    </button>
                  </li>

                  <li role="menuitem" aria-haspopup="true" aria-expanded="false">
                    <button className="flex items-center gap-1 text-base text-[#353543] font-medium hover:text-[#ca0d2d] transition-colors">
                      {t('navigation.contactUs')}
                    </button>
                  </li>

                  <li role="menuitem" aria-haspopup="true" aria-expanded="false">
                    <button
                      onClick={() => navigate('/wishlist')}
                      className="flex items-center gap-1 text-base text-[#353543] font-medium hover:text-[#ca0d2d] transition-colors"
                    >
                      {t('userMenu.wishlist')}
                    </button>
                  </li>

                  <li role="menuitem" aria-haspopup="true" aria-expanded="false">
                    <button
                      onClick={() => navigate('/order-history')}
                      className="flex items-center gap-1 text-base text-[#353543] font-medium hover:text-[#ca0d2d] transition-colors"
                    >
                      {t('userMenu.myOrders')}
                    </button>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
